<template>
  <el-config-provider :locale="zhCn">
    <div class="app" v-loading="mainLoading">
      <router-view></router-view>
    </div>
  </el-config-provider>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useStore } from './store'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
const store = useStore()
const mainLoading = computed(() => store.state.mainLoading)
</script>

<style lang="less">
.app {
  width: 100%;
  height: 100%;
}
</style>
